import type { SVGProps } from "react";

export const ZohoCreator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 1024 1024"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Zoho creator</title>

    <g>
      <path
        d="M532.63,1003.88c-0.01,0-0.01,0-0.02,0c-34.76,0-67.42-13.55-91.98-38.15L8.81,533.25
		c-11.69-11.71-11.69-30.68,0-42.39L440.74,58.27c24.56-24.6,57.23-38.15,91.99-38.15c0,0,0,0,0,0c34.76,0,67.43,13.55,91.99,38.15
		l153.64,153.88c11.69,11.71,11.69,30.68,0,42.39L521.33,511.98l257.04,257.44c11.7,11.71,11.69,30.69,0,42.4L624.6,965.75
		C600.04,990.34,567.38,1003.88,532.63,1003.88z M72.43,512.05l410.66,411.29c13.22,13.24,30.81,20.54,49.53,20.54
		c0,0,0.01,0,0.01,0c18.71,0,36.3-7.29,49.52-20.53l132.6-132.74L457.71,533.18c-11.69-11.71-11.69-30.68,0-42.39l257.04-257.44
		L582.27,100.66c-13.23-13.25-30.82-20.54-49.53-20.54c-18.72,0-36.31,7.29-49.54,20.54L72.43,512.05z"
        style={{ fill: "#226DB4" }}
      />
    </g>
    <g>
      <path
        d="M863.08,714.51c-7.96,0-15.6-3.17-21.23-8.8L669.58,533.18c-11.69-11.71-11.69-30.68,0-42.39l172.27-172.53
		c5.63-5.64,13.27-8.8,21.23-8.8c7.96,0,15.6,3.17,21.23,8.8l101.72,101.88c50.57,50.65,50.57,133.06,0,183.71L884.31,705.71
		C878.68,711.35,871.05,714.51,863.08,714.51z M733.21,511.98l129.87,130.07l80.49-80.61c27.23-27.27,27.23-71.65,0-98.92
		l-80.49-80.61L733.21,511.98z"
        style={{ fill: "#E42527" }}
      />
    </g>
  </svg>
);

export default ZohoCreator;
